const USER_AGENT = window.navigator.userAgent || ''

export const TOUCH_ENABLED = Boolean(
  document === window.document &&
    ('ontouchstart' in window || window.navigator.maxTouchPoints),
)

export const IS_FIREFOX = /Firefox/i.test(USER_AGENT)

export const IS_EDGE = /Edg/i.test(USER_AGENT)

export const IS_CHROMIUM =
  /Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT)

export const IS_CHROME = !IS_EDGE && IS_CHROMIUM

export const IS_ANDROID = /Android/i.test(USER_AGENT)

export const IS_SAFARI =
  /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE

export const IS_WINDOWS = /Windows/i.test(USER_AGENT)

export const IS_IPAD =
  /iPad/i.test(USER_AGENT) ||
  (IS_SAFARI && TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT))

export const IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD

export const IS_IPOD = /iPod/i.test(USER_AGENT)

export const IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD

export const IS_MOBILE = IS_IOS || IS_ANDROID
